export interface Project {
  id: number;
  title: string;
  category: string;
  location: string;
  year: number;
  duration: string;
  description: string;
  details: string[];
  image: string;
}

export const projects: Project[] = [
  {
    id: 1,
    title: 'Komplettsanierung Mehrfamilienhaus',
    category: 'Sanierung & Renovierung',
    location: 'Ratingen',
    year: 2024,
    duration: '14 Wochen',
    description: 'Vollständige energetische Sanierung eines Mehrfamilienhauses aus den 1970er-Jahren – von der Dämmung bis zur neuen Heizungsanlage.',
    details: ['Kernsanierung aller 8 Wohneinheiten', 'Neue Elektroinstallation', 'Modernisierung Sanitär', 'Neue Fenster & Türen'],
    image: 'https://public.readdy.ai/ai/img_res/855f9ff13b26049fd4bf13217edfbae1.jpg',
  },
  {
    id: 2,
    title: 'Naturstein-Terrasse mit Teichanlage',
    category: 'Garten- & Landschaftsbau',
    location: 'Düsseldorf',
    year: 2024,
    duration: '3 Wochen',
    description: 'Gestaltung einer großzügigen Naturstein-Terrasse mit integrierter Teichanlage, Bepflanzung und Beleuchtungskonzept.',
    details: ['45 m² Natursteinpflaster Granit', 'Schwimmteich 12 m²', 'Uferrandpflanzung', 'LED-Gartenbeleuchtung'],
    image: 'https://readdy.ai/api/search-image?query=beautiful%20natural%20stone%20patio%20terrace%20with%20ornamental%20garden%20pond%20water%20feature%20lush%20green%20plants%20flowers%20modern%20residential%20garden%20germany%20landscaping%20professional%20design%20bright%20summer%20daylight%20elegant&width=800&height=600&seq=proj-gala-001&orientation=landscape',
  },
  {
    id: 3,
    title: 'Bürokomplex Trockenbau & Decken',
    category: 'Trockenbau',
    location: 'Mettmann',
    year: 2024,
    duration: '6 Wochen',
    description: 'Kompletter Innenausbau eines modernen Bürokomplexes mit abgehängten Decken, Trennwänden und Akustiklösungen.',
    details: ['2.200 m² Systemdecken', 'Glastrennwände mit Schallschutz', 'Brandschutzverkleidungen', '42 Einzelbüros aufgeteilt'],
    image: 'https://readdy.ai/api/search-image?query=modern%20office%20interior%20finished%20drywall%20suspended%20ceiling%20installation%20open%20space%20bright%20white%20clean%20minimal%20corporate%20germany%20professional%20construction%20completed%20interior%20design&width=800&height=600&seq=proj-trock-001&orientation=landscape',
  },
  {
    id: 4,
    title: 'Fassadensanierung Wohnanlage',
    category: 'Fassade & Außenwände',
    location: 'Erkrath',
    year: 2023,
    duration: '8 Wochen',
    description: 'Vollständige Fassadensanierung einer 6-stöckigen Wohnanlage mit neuem WDVS-System und Außenputz in modernem Farbkonzept.',
    details: ['1.800 m² WDVS gedämmt', 'Strukturputz Außen', 'Neue Fensterbänke', 'Modernes Farbkonzept Grau/Weiß'],
    image: 'https://readdy.ai/api/search-image?query=modern%20freshly%20renovated%20apartment%20building%20facade%20exterior%20thermal%20insulation%20system%20WDVS%20new%20plaster%20gray%20white%20color%20scheme%20germany%20residential%20urban%20architecture%20professional%20sharp%20realistic%20photo&width=800&height=600&seq=proj-fass-001&orientation=landscape',
  },
  {
    id: 5,
    title: 'Rasenpflege & Beet-Neuanlage',
    category: 'Garten- & Landschaftsbau',
    location: 'Wuppertal',
    year: 2024,
    duration: '1 Woche',
    description: 'Neuanlage eines Zierrasens mit professioneller Rollrasen-Verlegung und Bepflanzung mehrerer Staudenbeete.',
    details: ['380 m² Rollrasen verlegt', '5 Staudenbeete angelegt', 'Bewässerungsanlage integriert', 'Wege in Kieseloptik'],
    image: 'https://readdy.ai/api/search-image?query=lush%20green%20freshly%20laid%20lawn%20roll%20grass%20residential%20garden%20with%20colorful%20flower%20beds%20perennials%20neat%20pathways%20gravel%20bright%20sunny%20day%20professional%20garden%20landscaping%20germany%20elegant%20neat%20outdoor%20space&width=800&height=600&seq=proj-gala-002&orientation=landscape',
  },
  {
    id: 6,
    title: 'Parkettverlegung Einfamilienhaus',
    category: 'Bodenbeläge',
    location: 'Hilden',
    year: 2023,
    duration: '5 Tage',
    description: 'Verlegung von massivem Eichenparkett in Fischgrät-Optik in einem komplett renovierten Einfamilienhaus.',
    details: ['220 m² Eichenparkett Fischgrät', 'Unterbodenausgleich', 'Sockelleisten in Weiß', 'Öl-Finish natur matt'],
    image: 'https://readdy.ai/api/search-image?query=elegant%20herringbone%20oak%20parquet%20floor%20newly%20installed%20bright%20modern%20living%20room%20interior%20germany%20residential%20renovation%20warm%20wood%20tones%20natural%20light%20beautiful%20craftsmanship%20clean&width=800&height=600&seq=proj-boden-001&orientation=landscape',
  },
  {
    id: 7,
    title: 'Pflasterarbeiten Einfahrt & Hof',
    category: 'Garten- & Landschaftsbau',
    location: 'Solingen',
    year: 2023,
    duration: '2 Wochen',
    description: 'Pflasterung einer Doppeleinfahrt und eines großen Hofbereiches mit Granit-Großpflaster und integrierter Rinnenplanung.',
    details: ['310 m² Granitpflaster verlegt', 'Randsteine Granit', 'Entwässerungsrinnen', 'Tiefbau & Fundament'],
    image: 'https://readdy.ai/api/search-image?query=new%20granite%20stone%20paving%20driveway%20courtyard%20residential%20property%20professional%20landscaping%20germany%20clean%20neat%20precise%20stonework%20modern%20house%20exterior%20daylight%20sharp%20realistic%20photo&width=800&height=600&seq=proj-gala-003&orientation=landscape',
  },
  {
    id: 8,
    title: 'Innenraumgestaltung Altbau',
    category: 'Malerarbeiten',
    location: 'Leverkusen',
    year: 2024,
    duration: '2 Wochen',
    description: 'Komplette malerische Gestaltung eines Altbaus mit Stucksanierung, dekorativen Wandfarben und Tapezierarbeiten.',
    details: ['480 m² Wände & Decken', 'Stuck restauriert & gestrichen', 'Designertapeten 3 Räume', 'Farbkonzept professionell'],
    image: 'https://readdy.ai/api/search-image?query=beautifully%20painted%20historic%20apartment%20interior%20germany%20fresh%20bright%20walls%20restored%20stucco%20ceiling%20decorative%20wallpaper%20elegant%20color%20concept%20natural%20light%20professional%20painting%20renovation%20classic%20charm&width=800&height=600&seq=proj-mal-001&orientation=landscape',
  },
  {
    id: 9,
    title: 'Gartenplanung Lageplan & Ausführung',
    category: 'Bauzeichnungen',
    location: 'Velbert',
    year: 2024,
    duration: '4 Wochen',
    description: 'Von der Bauzeichnung bis zur fertigen Anlage: detaillierter Lageplan, Bepflanzungsplan und vollständige Umsetzung.',
    details: ['Lageplan M 1:100', 'Bepflanzungsplan', 'Entwässerungsplanung', 'Ausführung nach Plan komplett'],
    image: 'https://readdy.ai/api/search-image?query=professional%20landscape%20architecture%20garden%20planning%20drawing%20blueprint%20technical%20plan%20on%20desk%20with%20finished%20beautiful%20garden%20in%20background%20germany%20design%20drafting%20precise%20ruler%20pencil%20bright%20studio%20clean&width=800&height=600&seq=proj-zeich-001&orientation=landscape',
  },
  {
    id: 10,
    title: 'Bad-Komplettsanierung',
    category: 'Sanierung & Renovierung',
    location: 'Mönchengladbach',
    year: 2023,
    duration: '3 Wochen',
    description: 'Kernsanierung eines Badezimmers mit neuer Fliesenverlegung, modernen Sanitärobjekten und barrierefreier Duschlösung.',
    details: ['Walk-In Dusche barrierefrei', '120 m² Fliesen verlegt', 'Neue Sanitärinstallation', 'Fußbodenheizung eingebaut'],
    image: 'https://readdy.ai/api/search-image?query=luxurious%20newly%20renovated%20bathroom%20interior%20germany%20large%20format%20tiles%20walk%20in%20shower%20modern%20fixtures%20freestanding%20bathtub%20bright%20white%20minimalist%20design%20natural%20light%20professional%20renovation%20complete&width=800&height=600&seq=proj-san-002&orientation=landscape',
  },
  {
    id: 11,
    title: 'Außenanlage Gewerbegebäude',
    category: 'Garten- & Landschaftsbau',
    location: 'Krefeld',
    year: 2024,
    duration: '5 Wochen',
    description: 'Komplette Außenanlage eines Gewerbegebäudes mit Parkplatzbegrünung, Zaunanlage und repräsentativer Eingangsgestaltung.',
    details: ['Parkplatzbegrünung 600 m²', 'Heckenpflanzung 120 lm', 'Eingangsgestaltung Naturstein', 'Zaunanlage 180 m'],
    image: 'https://readdy.ai/api/search-image?query=professional%20commercial%20building%20outdoor%20landscape%20design%20germany%20neat%20green%20hedges%20natural%20stone%20entrance%20area%20parking%20lot%20greenery%20modern%20architecture%20bright%20daylight%20clean%20corporate%20exterior&width=800&height=600&seq=proj-gala-004&orientation=landscape',
  },
  {
    id: 12,
    title: 'Klinker-Fassade Neubau',
    category: 'Fassade & Außenwände',
    location: 'Neuss',
    year: 2023,
    duration: '5 Wochen',
    description: 'Klinkerverblendung einer Neubaufassade mit handwerklich hochwertigem Mauerwerk und individueller Fugengestaltung.',
    details: ['780 m² Klinker verblendet', 'Rollladenkästen verkleidet', 'Balkonbrüstungen Klinker', 'Anthrazit-Fugen gesetzt'],
    image: 'https://readdy.ai/api/search-image?query=new%20modern%20residential%20building%20with%20high%20quality%20red%20brick%20clinker%20facade%20germany%20professional%20masonry%20precise%20mortar%20joints%20clean%20architecture%20sunny%20day%20sharp%20realistic%20photo%20exterior&width=800&height=600&seq=proj-fass-002&orientation=landscape',
  },
  {
    id: 13,
    title: 'Rohbau Einfamilienhaus — Erweiterungsanbau',
    category: 'Bau & Sanierungsdienste',
    location: 'Ratingen',
    year: 2026,
    duration: '10 Wochen',
    description: 'Erster Auftrag der neuen Sparte: Rohbau eines zweigeschossigen Anbaus an ein Bestandsgebäude — Fundament, Mauerwerk, Decken und Dachstuhl aus einer Hand.',
    details: ['Fundament & Bodenplatte gegossen', 'Mauerwerk KS-Stein 2 Vollgeschosse', 'Stahlbetondecke eingebaut', 'Dachstuhl Holz aufgestellt'],
    image: 'https://readdy.ai/api/search-image?query=new%20residential%20building%20extension%20raw%20construction%20shell%20structure%20germany%20brick%20masonry%20two%20story%20addition%20modern%20house%20daylight%20bright%20professional%20clean%20construction%20site%20progress&width=800&height=600&seq=proj-bau-2026-001&orientation=landscape',
  },
  {
    id: 14,
    title: 'Vollsanierung Gewerbeeinheit — Innen & Außen',
    category: 'Bau & Sanierungsdienste',
    location: 'Düsseldorf',
    year: 2026,
    duration: '12 Wochen',
    description: 'Umfassende Sanierung einer leerstehenden Gewerbeeinheit: Kernentkernung, neue Grundrissstruktur, Fassade, Elektro und kompletter Innenausbau bis zur Übergabe.',
    details: ['Kernentkernung & Grundrissplanung', 'Neue Fassade & Fenster', 'Elektro- & Sanitärinstallation komplett', 'Trockenbau & Bodenbelag fertig'],
    image: 'https://readdy.ai/api/search-image?query=completely%20renovated%20commercial%20retail%20space%20interior%20germany%20fresh%20white%20walls%20modern%20ceiling%20lighting%20open%20floor%20plan%20professional%20renovation%20completed%20bright%20daylight%20clean%20minimal&width=800&height=600&seq=proj-bau-2026-002&orientation=landscape',
  },
];

export const categories = [
  'Alle',
  'Bau & Sanierungsdienste',
  'Sanierung & Renovierung',
  'Garten- & Landschaftsbau',
  'Trockenbau',
  'Fassade & Außenwände',
  'Bodenbeläge',
  'Malerarbeiten',
  'Bauzeichnungen',
];
